import React, { useState, useEffect, useRef } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import _ from "lodash"
import Title from "../general/title"
import helpers from "helpers/helpers"
import FullTable from "components/FullTable"
import getData from "helpers/asyncSubmitData"
import settings from "settings"
import { toast } from "react-toastify"
import moment from "moment"

function ARCReport(props) {
	const [planRows, setPlanRows] = useState([])
	const tableRef = useRef(null)
	useEffect(() => {
		buildRows()
	}, [])

	const buildRows = () => {
		let ret = []
		_.forEach(props.payload.exec.lots, (v) => {
			if (v.arc_approved !== 1) return
			let builder = _.find(props.payload.public.builders, { id: v.builder })
			let lt = _.find(props.payload.public.lot_types, { id: v.lot_type })
			let section = _.find(props.payload.public.sections, { id: v.section_id })
			let submitted_by = _.find(props.payload.users, { id: v?.arc_data?.user })
			let days_difference

			if (v.arc_data?.approval_date && v.arc_data?.addedDate) {
				days_difference = moment.unix(v.arc_data.approval_date).diff(moment.unix(v.arc_data.addedDate), "days")
			}
			ret.push({
				id: v.id,
				address: v.address,
				builder: builder?.name || "",
				lot_type: lt?.name || "",
				section: section?.name || "",
				submit_date: v.arc_data?.addedDate || null,
				start_date: v.start_date || null,
				approved_date: v.arc_data?.approval_date || null,
				days_difference,
				submitted_by: submitted_by?.id ? `${submitted_by.first} ${submitted_by.last}` : "",
				plan_file: v.arc_data?.plan_file ? (
					<a href={`${settings.s3}${v.arc_data?.plan_file}`} target="_blank">
						View Plan
					</a>
				) : null,
			})
		})
		setPlanRows(ret)
	}

	const downloadDocuments = async () => {
		// not used anymore as the files are too large, but keeping in case.
		const filteredRows = tableRef.current.getResolvedState ? tableRef.current.getResolvedState().sortedData : []
		const ids = filteredRows.map((row) => row._original.id).filter(Boolean)
		if (Array.isArray(ids) && ids.length > 50) {
			toast.error(
				"You can only download documents for 50 rows at a time. Please filter your results and try again."
			)
			return
		}
		let resp = await getData("mainRetrieve", {
			action: "massDownloadARCDocuments",
			ids: ids,
		})
		console.log(resp)
	}

	if (props.activeProperties.length !== 1) {
		return (
			<div className="pleaseChoose">
				<h1>Please choose one community to administer.</h1>
			</div>
		)
	}
	return (
		<div>
			<Title title="ARC Report" />
			{/* <div className="flex justify-end">
				<div
					className="btn text-xs"
					onClick={() => {
						downloadDocuments()
					}}>
					Download Row's Document Dump
				</div>
			</div> */}
			<div className="content">
				<h2>Approved Site Plans</h2>
				<FullTable
					onTableStateChange={(table) => {
						tableRef.current = table
					}}
					data={planRows}
					columns={[
						{
							Header: "Address",
							accessor: "address",
							filterMethod: (f, r) => helpers.tableText(f, r, "address"),
						},
						{
							Header: "Builder",
							accessor: "builder",
							filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
						},
						{
							Header: "Lot Type",
							accessor: "lot_type",
							filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
						},
						{
							Header: "Section",
							accessor: "section",
							filterMethod: (f, r) => helpers.tableText(f, r, "section"),
						},
						{
							Header: "Submitted By",
							accessor: "submitted_by",
							filterMethod: (f, r) => helpers.tableText(f, r, "submitted_by"),
						},
						{
							Header: "Submit Date",
							accessor: "submit_date",
							filterMethod: (f, r) => helpers.tableText(f, r, "submit_date"),
							Cell: (v) => helpers.tableDate(v),
						},
						{
							Header: "Approved Date",
							accessor: "approved_date",
							filterMethod: (f, r) => helpers.tableText(f, r, "approved_date"),
							Cell: (v) => helpers.tableDate(v),
						},
						{
							Header: "Days Difference",
							accessor: "days_difference",
							filterMethod: (f, r) => helpers.tableText(f, r, "days_difference"),
						},
						{
							Header: "Start Date",
							accessor: "start_date",
							filterMethod: (f, r) => helpers.tableText(f, r, "start_date"),
							Cell: (v) => helpers.tableDate(v),
						},
						{
							Header: "Plan File",
							accessor: "plan_file",
							filterMethod: (f, r) => helpers.tableText(f, r, "plan_file"),
						},
					]}
					name="arcReport"
					title="ARC Report"
				/>
			</div>
		</div>
	)
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default connect(mapStateToProps, matchDispatchToProps)(ARCReport)
